import { emitAppEvent } from '@/events/eventBus'
import { AppEvents } from '@/events/eventTypes'
import useAppStore from '@/store/useAppStore'
import {
  ActivityTypeUtil,
  NotificationItem,
  SocketEventType,
  SocketMessage,
} from '@/types/notification'

interface SocketVariableData {
  topicApplication?: number
  topicType?: number
  visibility?: number
  extraData?: Record<string, any>[]
}
const useNotificationStorageHook = () => {
  const { addSocketMessage } = useAppStore()

  const parseVariableDataText = (text: string) => {
    let result: SocketVariableData = {}
    if (text?.length > 0) {
      // Extracting varData and parsing separately, because split by comma can break
      // because of JSON string inside varData

      let updated = text
      let varDataIndex = text.indexOf(',varData=')
      const varDataSubStr = text.substring(varDataIndex)
      updated = text.replace(varDataSubStr, '')
      let variableData: Record<string, any>[] = []

      if (varDataSubStr.length > 0) {
        const variableDataParts = varDataSubStr.split('=')
        if (variableDataParts.length > 1) {
          const varDataValue = variableDataParts[1]
          if (varDataValue?.length > 0 && varDataValue?.startsWith('[')) {
            variableData = JSON.parse(varDataValue)
          }
        }
      }
      let components = updated.split(',')
      const mappedObject = components.reduce(
        (acc: Record<string, string | null>, item: string) => {
          const parts = item.split('=')
          if (parts.length > 0) {
            let value: string | null = null
            const keyName = parts[0]
            if (parts.length > 1) {
              value = parts[1]
            }
            acc[keyName] = value
          }
          return acc
        },
        {} as Record<string, string | null>,
      )

      result = {
        ...mappedObject,
        extraData: variableData,
      }
    }
    return result
  }

  const addMessage = (message: SocketMessage) => {
    const varDataObject = parseVariableDataText(message?.eventData?.variableData || '')
    const item: NotificationItem = {
      ...message.eventData,
      isRead: false,
      topicApplication: varDataObject?.topicApplication || 20,
      topicType: varDataObject?.topicType || 100,
      visibility: varDataObject?.visibility || 1,
      extraData: varDataObject.extraData || [],
    }

    if (item.eventType == SocketEventType.CONNECTION_REQUESTED) {
      emitAppEvent(AppEvents.REFETCH_REQUESTS)
    } else if (ActivityTypeUtil.isSocketEventSupported(item.eventType)) {
      if (item.eventType == SocketEventType.USER_CONNECTED) {
        emitAppEvent(AppEvents.REFETCH_CONNECTIONS)
      } else if (
        item.eventType == SocketEventType.TOPIC_NOTE_LIKED ||
        item.eventType == SocketEventType.TOPIC_NOTE_UNLIKED
      ) {
        emitAppEvent(AppEvents.NOTE_LIKE_STATUS_UPDATED, {
          topicID: ActivityTypeUtil.getTopicID(item),
          noteID: ActivityTypeUtil.getNoteID(item),
          isLiked: item.eventType == SocketEventType.TOPIC_NOTE_LIKED,
        })
      } else if (item.eventType == SocketEventType.TOPIC_VIEWED) {
        emitAppEvent(AppEvents.TOPIC_VIEWED, { topicID: ActivityTypeUtil.getTopicID(item) })
      }

      if (ActivityTypeUtil.isSocketEventStorageSupported(item.eventType)) addSocketMessage(item)
    }
  }

  return { addMessage }
}

export default useNotificationStorageHook
